export default {
  methods: {
    separateDateElements (date) {
      const dateSeparated = date.split('/')

      return [
        dateSeparated[0],
        dateSeparated[1],
        dateSeparated[2]
      ]
    }
  }
}
